import { render } from "./NumberBadge.vue?vue&type=template&id=5b31f60a"
import script from "./NumberBadge.vue?vue&type=script&lang=js"
export * from "./NumberBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/demonology/demonology/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__